/** 只保留最新一份文件的原生下载链接，供自动保存被浏览器拦下时手动点击。 */
export function createDownloadPanel(host: HTMLElement, urls: Pick<typeof URL, 'createObjectURL' | 'revokeObjectURL'> = URL) {
  const doc = host.ownerDocument;
  const title = doc.createElement('strong'); title.textContent = '文件已生成';
  const note = doc.createElement('span'); note.textContent = '已尝试自动保存；如果没有出现文件，请点击下面的链接保存。此处只保留最新一份文件。';
  const link = doc.createElement('a');
  const close = doc.createElement('button'); close.type = 'button'; close.textContent = '关闭'; close.setAttribute('aria-label', '关闭下载提示并释放文件链接');
  host.append(title, note, link, close); host.hidden = true;
  let activeURL: string | null = null;
  const clear = () => {
    if (activeURL != null) urls.revokeObjectURL(activeURL);
    activeURL = null; host.hidden = true;
    link.removeAttribute('href'); link.removeAttribute('download'); link.textContent = '';
  };
  close.addEventListener('click', clear);
  return {
    clear,
    show(blob: Blob, filename: string, format: string): HTMLAnchorElement {
      const next = urls.createObjectURL(blob);
      if (activeURL != null) urls.revokeObjectURL(activeURL);
      activeURL = next;
      link.href = next; link.download = filename;
      link.textContent = `点击下载 ${format.toUpperCase()}：${filename}`;
      host.hidden = false;
      return link;
    },
  };
}
